import * as React from 'react';
import type { SVGProps } from 'react';
const SvgMinus = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" width="1em" height="1em" {...props}>
    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M12.7 8H3.367" />
    <path fill="currentColor" fillRule="evenodd" d="M13.2 8a.5.5 0 0 1-.5.5H3.367a.5.5 0 0 1 0-1H12.7a.5.5 0 0 1 .5.5" clipRule="evenodd" />
  </svg>
);
export default SvgMinus;
